import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const MARYLINE_AVATAR =
  "https://static.prod-images.emergentagent.com/jobs/2ad66ef0-cb2f-4266-9e15-3318c766d8a0/images/9868851bb866a434671bb5732fa47bdbbf209e8feddc78354178b56e2ce39a01.jpeg";
export const MARYLINE_HERO =
  "https://static.prod-images.emergentagent.com/jobs/2ad66ef0-cb2f-4266-9e15-3318c766d8a0/images/391aa99f6860366052bb2ca78c67e6d5a9d8c831f6c8baea7269e419bdb420d4.jpeg";
